/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type ReassignSubmissionParams = {
  to_lecturer_id: string;
  to_lecturer_title: string;
};
